import { AssemblyOrderEnum, AssemblyPoolShellStatusEnum, AssemblyTaskStatusEnum } from "src/app/shared/enumerators/assembly-order.enum"

const SAP_ProductStates: any = [
  {
    "id": AssemblyTaskStatusEnum.Pendiente,
    "description": "Pendiente",
    "icon": "build",
    "color": "#c4c4c4",
    "enabled": true,
  },
  {
    "id": AssemblyTaskStatusEnum.Modificada,
    "description": "Modificado",
    "icon": "priority_high",
    "color": "#ffa000",
    "enabled": false,
  },
  {
    "id": AssemblyTaskStatusEnum.EnProceso,
    "description": "En Proceso",
    "icon": "build",
    "color": "#00a8f0",
    "enabled": true,
  },
  {
    "id": AssemblyTaskStatusEnum.Listo,
    "description": "Listo",
    "icon": "done",
    "color": "#4caf50",
    "enabled": true,
  }
]

const SAP_PoolStates: any = [
  {
    "id": AssemblyPoolShellStatusEnum.Pendiente,
    "description": "Pendiente",
    "icon": "build",
    "color": "#c4c4c4",
    "enabled": true,
  },
  {
    "id": AssemblyPoolShellStatusEnum.Modificada,
    "description": "Modificado",
    "icon": "priority_high",
    "color": "#ffa000",
    "enabled": false,
  },
  {
    "id": AssemblyPoolShellStatusEnum.Programada,
    "description": "Programado",
    "icon": "alarm",
    "color": "#997BDA",
    "enabled": true,
  },
  {
    "id": AssemblyPoolShellStatusEnum.Listo,
    "description": "Listo",
    "icon": "done",
    "color": "#4caf50",
    "enabled": true,
  }
]

export { SAP_ProductStates, SAP_PoolStates }